'use strict';


export const lazyLoadTurnstile = (observedFormSelector, widgetContainerSelector) => {
    const target = document.querySelector(observedFormSelector);

    if (!target) {
        return;
    }

    let rendered = false;

    const observer = new IntersectionObserver(entries => {
        if (!rendered && entries[0].isIntersecting) {
            renderTurnstileWidget(widgetContainerSelector);
            rendered = true;
        }
    });

    observer.observe(target);
};

export const renderTurnstileWidget = (widgetContainerSelector) => {
    const containers = document.querySelectorAll(widgetContainerSelector);

    if (!containers.length) {
        console.warn('Turnstile widget container(s) not found:', widgetContainerSelector);
        return;
    }

    if (typeof turnstile === 'undefined') {
        console.warn('Turnstile is not loaded.');
        return;
    }

    containers.forEach(container => {
        const renderedWidget = container.querySelector('input[name="cf-turnstile-response"]');
        if (renderedWidget && renderedWidget.id) {
            const widgetId = renderedWidget.id.split('_response')[0];
            turnstile.reset(widgetId);
            turnstile.remove(widgetId);
        } else if (container.children.length > 0) {
            container.innerHTML = '';
        }

        turnstile.render(container, {
            sitekey: window.SitePreferences.TURNSTILE_SITE_KEY,
            callback: function (token) {
                // console.log('Success:', token);
            },
        });
    });
};

function removePreviousChallange(container) {
    const renderedWidget = container.querySelector('input[name="cf-turnstile-response"]');
    if (renderedWidget && renderedWidget.id) {
        const widgetId = renderedWidget.id.split('_response')[0];
        turnstile.reset(widgetId);
        turnstile.remove(widgetId);
    }
}

export const callTurnstile = (AJAXCallback, container, ...args) => {
    if (typeof turnstile !== 'undefined') {
        removePreviousChallange(container);
        turnstile.render(container, {
            sitekey: window.SitePreferences.TURNSTILE_SITE_KEY,
            callback: function (token) {
                AJAXCallback(token, ...args);
            }
        });
    } else {
        AJAXCallback('');
    }
};

export default {
    renderTurnstileWidget,
    lazyLoadTurnstile,
    callTurnstile,
};
